module.exports = {
	"root": "findify-components--range-facet",
	"content": "findify-components--range-facet__content",
	"item": "findify-components--range-facet__item",
	"range": "findify-components--range-facet__range",
	"input-block": "findify-components--range-facet__input-block",
	"inputBlock": "findify-components--range-facet__input-block",
	"input-wrap": "findify-components--range-facet__input-wrap",
	"inputWrap": "findify-components--range-facet__input-wrap",
	"input": "findify-components--range-facet__input",
	"currency": "findify-components--range-facet__currency",
	"submit": "findify-components--range-facet__submit",
	"divider": "findify-components--range-facet__divider"
};